import React, { useState } from "react";
import {
  Row,
  Col,
  Container,
  Button,
  OverlayTrigger,
  Tooltip,
  Nav,
} from "react-bootstrap";
import TooltipIconOne from "../assets/images/tooltip-2.svg";
import MapPoint from "../assets/images/map-point.svg";
import PopularIcon from "../assets/images/popular.svg";
import ContactAgentModal from "./ContactAgentModal";
import RequestTourModal from "./RequestTourModal";
import ConfirmTourModal from "./ConfirmTourModal";
import ClockIcon from "../assets/images/about-home/1.svg";
import TownhomeIcon from "../assets/images/about-home/2.svg";
import YearBuiltIcon from "../assets/images/about-home/3.svg";
import LotSizeIcon from "../assets/images/about-home/4.svg";
import PricePerSqFtIcon from "../assets/images/about-home/5.svg";
import DownArrow from "../assets/images/down-arrow.svg";
import HomePersonIcon from "../assets/images/home-icon.svg";
import CalendarIcon from "../assets/images/calendar-about.svg";
import WalkIcon from "../assets/images/man-1.svg";
import BikeIcon from "../assets/images/man-2.svg";
import ArrowRight from "../assets/images/arrow-right.svg";
import EditIcon from "../assets/images/edit.svg";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { getViewingCopy } from "../utils/viewingCopy";
import DealIcon from "../assets/images/deal-icon.svg";

import {
  formatCreatedAt,
  formatDateTime,
  formatTourTime,
  timeAgo,
  formatOpenHouse,
} from "../utils/date";
import { getScoreLabel } from "../utils/scores";
import { calculateMonthlyMortgage } from "../utils/calculator";
import { Form } from "react-bootstrap";

function ProductDetails({ property }) {
  const navigate = useNavigate();
  const [showFullDescription, setShowFullDescription] = useState(false);
  const [showPropertyFullDescription, setShowPropertyFullDescription] =
    useState(false);
  const [activeTab, setActiveTab] = useState("school");
  const [showInsuranceDetails, setShowInsuranceDetails] = useState(false);
  const [downPayment, setDownPayment] = useState(50980);
  const [loanDetails, setLoanDetails] = useState("30-yr fixed, 6.38%");
  const { title, description } = getViewingCopy(property.total_viewings);
  const created_at = formatCreatedAt(property.created_at);
  const updated_at = formatDateTime(property.updated_at);
  const last_viewed = timeAgo(property.last_viewed_at);
  const MAX_LENGTH = 320;

  const shortDescription =
    property.description.length > MAX_LENGTH
      ? property.description.slice(0, MAX_LENGTH)
      : property.description;

  const [showContactModal, setShowContactModal] = useState(false);
  const handleShowContactModal = () => setShowContactModal(true);
  const handleCloseContactModal = () => setShowContactModal(false);
  const [showRequestTourModal, setShowRequestTourModal] = useState(false);
  const [showConfirmTourModal, setShowConfirmTourModal] = useState(false);
  const [tourData, setTourData] = useState(null);
  const handleShowRequestTour = () => setShowRequestTourModal(true);
  const handleCloseRequestTour = () => setShowRequestTourModal(false);
  const handleShowConfirmTour = () => setShowConfirmTourModal(true);
  const handleCloseConfirmTour = () => setShowConfirmTourModal(false);
  const handleNextFromRequestTour = (data) => {
    setTourData(data);
    setShowRequestTourModal(false);
    setShowConfirmTourModal(true);
  };

  const [isEditingDownPayment, setIsEditingDownPayment] = useState(false);
  const [downPaymentPercent, setDownPaymentPercent] = useState(
    property.down_payment_percent,
  );
  const [isEditingPrice, setIsEditingPrice] = useState(false);
  const [homePrice, setHomePrice] = useState(property.price);
  const [isEditingLoan, setIsEditingLoan] = useState(false);
  const [loanYears, setLoanYears] = useState(property.loan_years);
  const [interestRate, setInterestRate] = useState(property.interest_rate);

  const [calculatorResults, setCalculatorResults] = useState(
    calculateMonthlyMortgage(
      property.price,
      downPaymentPercent,
      property.interest_rate,
      property.loan_years || 0,
    ),
  );

  const paymentBreakdown = [
    {
      label: "Principal and Interest",
      value: calculatorResults.principalInterest,
      color: "#B3EAE8",
    },
    {
      label: "Property taxes",
      value: calculatorResults.taxes,
      color: "#2658D9",
    },
    { label: "HOA dues", value: 0, color: "#F4B7C2" },
    {
      label: "Home Insurance",
      value: calculatorResults.insurance,
      color: "#ED8535",
    },
  ];

  const commitEdit = () => {
    setIsEditingDownPayment(false);
    setIsEditingPrice(false);
    setIsEditingLoan(false);

    setCalculatorResults(
      calculateMonthlyMortgage(
        homePrice, // state for edited Home Price
        downPaymentPercent, // state for edited Down Payment
        interestRate, // state for edited Interest Rate
        loanYears || 0, // state for edited Loan Years
      ),
    );
  };

  const resetCalculator = () => {
    // Reset state to initial property values
    setHomePrice(property.price);
    setDownPaymentPercent(property.down_payment_percent);
    setLoanYears(property.loan_years);
    setInterestRate(property.interest_rate);

    // Exit all edit modes
    setIsEditingDownPayment(false);
    setIsEditingPrice(false);
    setIsEditingLoan(false);

    // Recalculate mortgage
    setCalculatorResults(
      calculateMonthlyMortgage(
        property.price,
        property.down_payment_percent,
        property.interest_rate,
        property.loan_years,
      ),
    );
  };

  return (
    <>
      <div className="product-info-section">
        <Container>
          <Row>
            <Col md={12} lg={8} xl={9}>
              <div className="sale-box">
                <Row className="g-4">
                  <Col md={12} lg={8} xl={9}>
                    {/* Status Badge */}
                    <p className="badge">
                      <span className="active"></span>
                      FOR SALE
                    </p>

                    {/* Price Section */}
                    <div className="price-section">
                      <h1 className="price-main">
                        KES{property.display_price}
                      </h1>
                      <div className="d-flex align-items-center flex-wrap price-sub">
                        <span>Est. KES{calculatorResults.totalMonthly}/mo</span>
                        <Button
                          variant="link"
                          className="text-decoration-none"
                          onClick={() => navigate("/get-pre‑qualified")}
                        >
                          Get Prequalified
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id="prequalified-tooltip">
                                Get prequalified to see how much you can afford
                                and strengthen your offer.
                              </Tooltip>
                            }
                          >
                            <img src={TooltipIconOne} alt="" />
                          </OverlayTrigger>
                        </Button>
                      </div>
                    </div>

                    {/* Property Details */}
                    <div className="property-details d-flex align-items-center">
                      <span>{property.details.bedrooms} bd</span>
                      <span className="dot"></span>
                      <span>{property.details.bathrooms} ba</span>
                      <span className="dot"></span>
                      <span>{property.size_sqft} sq ft</span>
                    </div>

                    {/* Address */}
                    <div className="address-section">
                      <p>{property.street_address}</p>
                    </div>
                  </Col>

                  {/* Map Column */}
                  <Col md={12} lg={4} xl={3}>
                    <div
                      className="map-container rounded overflow-hidden shadow-sm"
                      style={{ height: "129px" }}
                    >
                      <iframe
                        src={`https://www.google.com/maps?q=${property.latitude},${property.longitude}&z=15&output=embed`}
                        width="100%"
                        height="100%"
                        style={{ border: 0, pointerEvents: "none" }}
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Property Location"
                      />
                      <div className="custom-map-marker">
                        <img src={MapPoint} alt="Map Marker" />
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
              <div className="popular">
                <div className="popular-box">
                  <div className="popular-icon">
                    <img src={PopularIcon} alt="Popular" />
                  </div>
                  <div className="popular-content">
                    <h5>{title}</h5>
                    <p>{description}</p>
                  </div>
                </div>
                <p className="time-tag">{created_at}</p>
                <div className="tour-times d-flex flex-wrap align-items-center">
                  {/*Map slot_start_times*/}
                  {property.slot_start_times.map((time, index) => (
                    <React.Fragment key={index}>
                      <Button
                        variant="link"
                        className="text-decoration-none view-more"
                      >
                        {time}
                      </Button>
                      {index < property.slot_start_times.length - 1 && (
                        <span className="dot"></span>
                      )}
                    </React.Fragment>
                  ))}
                </div>
              </div>
              <div className="about-home" id="About">
                <h3>About this home</h3>

                {/* Description */}
                <div className="about-description">
                  <p>
                    {showFullDescription
                      ? property.description
                      : shortDescription}
                    {!showFullDescription &&
                      property.description.length > MAX_LENGTH &&
                      "..."}
                  </p>
                  <Button
                    variant="link"
                    className="p-0 text-decoration-none show-more-btn"
                    onClick={() => setShowFullDescription(!showFullDescription)}
                  >
                    {showFullDescription ? "Show Less" : "Show More"}
                    <img
                      src={DownArrow}
                      alt=""
                      className={showFullDescription ? "rotate-180" : ""}
                    />
                  </Button>
                </div>

                {/* Property Info Grid */}
                {property.deals?.length > 0 &&
                  property.deals.map((item, index) => (
                    <div className="deal-card" key={index}>
                      <div className="deal-icon">
                        <img src={DealIcon} alt="Deal" />
                      </div>
                      <div className="deal-content">
                        <h6>Deal</h6>
                        <p>{item.description}</p>
                      </div>
                    </div>
                  ))
                }
                <Row className="g-3 mb-3">
                  <Col md={6} lg={4}>
                    <div className="info-card">
                      <div className="info-icon ">
                        <img src={ClockIcon} alt="Days on Real Estate" />
                      </div>
                      <div className="info-content">
                        <h6>6 Days</h6>
                        <p>On Real Estate</p>
                      </div>
                    </div>
                  </Col>

                  <Col md={6} lg={4}>
                    <div className="info-card">
                      <div className="info-icon me-3">
                        <img src={TownhomeIcon} alt="Property Type" />
                      </div>
                      <div className="info-content">
                        <h6 className="mb-0 fw-bold">
                          {property.category?.name}
                        </h6>
                        <p className="mb-0 text-muted small">Property Type</p>
                      </div>
                    </div>
                  </Col>

                  <Col md={6} lg={4}>
                    <div className="info-card">
                      <div className="info-icon me-3">
                        <img src={YearBuiltIcon} alt="Year Built" />
                      </div>
                      <div className="info-content">
                        <h6 className="mb-0 fw-bold">{property.year_built}</h6>
                        <p className="mb-0 text-muted small">Year Built</p>
                      </div>
                    </div>
                  </Col>

                  <Col md={6} lg={4}>
                    <div className="info-card">
                      <div className="info-icon me-3">
                        <img src={LotSizeIcon} alt="Lot Size" />
                      </div>
                      <div className="info-content">
                        <h6 className="mb-0 fw-bold">
                          {property.size_sqft} sq ft
                        </h6>
                        <p className="mb-0 text-muted small">Lot Size</p>
                      </div>
                    </div>
                  </Col>
                </Row>

                {/* Listing Information */}
                <div className="listing-info">
                  <div className="listing-info-box">
                    <span>Listed by {property.listing_by?.name}</span>
                    {property.listing_by.company_name && (
                      <>
                        <span className="dot"></span>
                        <span>{property.listing_by.company_name}</span>
                      </>
                    )}

                    <span className="dot"></span>
                    <span>{property.listing_by.phone_number}</span>
                    <span className="dot"></span>
                    <span>{property.listing_by.email}</span>
                  </div>
                  <p>Listing updated: {updated_at}</p>
                  <div className="listing-info-box mb-0">
                    {property.last_viewed_at && (
                      <p>
                        Real Estate checked :{" "}
                        <span className="me-0">{last_viewed}</span>
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="home-person">
                <h3>See this home in person</h3>

                {/* Info Box */}
                <div className="home-person-info">
                  <div className="home-icon">
                    <img src={HomePersonIcon} alt="Home Person" />
                  </div>
                  <div className="home-info-text">
                    <p className="mb-0">
                      We'll connect you with a local agent to show you this
                      home, answer your questions, and assist you on your buying
                      journey.
                    </p>
                  </div>
                </div>

                {/* Next Available Tour */}
                {property.nextAvailableTour?.start_time && (
                  <div className="next-tour">
                    <div>
                      <span>Next available tour time:</span>{" "}
                      <strong>
                        {formatTourTime(property.nextAvailableTour.start_time)}
                      </strong>
                    </div>
                  </div>
                )}

                {/* Open Houses */}
                {property.openHouses.length > 0 && (
                  <div className="open-houses">
                    <h4>Open houses</h4>
                    <Row className="g-3">
                      {property.openHouses.map((house, index) => {
                        const { dayLabel, timeRange } = formatOpenHouse(
                          house.start_time,
                          house.end_time,
                        );

                        return (
                          <Col xs={12} md={4} key={index}>
                            <div className="open-house-card">
                              <img src={CalendarIcon} alt="Calendar" />
                              <h6>{dayLabel}</h6>
                              <p>{timeRange}</p>
                            </div>
                          </Col>
                        );
                      })}
                    </Row>
                  </div>
                )}
              </div>
              <div className="around-home mt-4" id="Neighborhood">
                <h3 className="mb-3">Around this home</h3>

                {/* Walk and Bike Score */}
                <div className="score-card-wrap">
                  {property.scores?.walk_score && (
                    <div className="score-card">
                      <img src={WalkIcon} alt="Walk" />
                      <p>
                        {property.scores.walk_score}/100{" "}
                        {getScoreLabel(property.scores.walk_score, "walk")}
                      </p>
                    </div>
                  )}
                  {property.scores?.bike_score && (
                    <div className="score-card">
                      <img src={BikeIcon} alt="Bike" />
                      <p>
                        {property.scores.bike_score}/100{" "}
                        {getScoreLabel(property.scores.bike_score, "bike")}
                      </p>
                    </div>
                  )}
                </div>

                {/* Map */}
                <div
                  className="around-map overflow-hidden"
                  style={{ height: "250px" }}
                >
                  <iframe
                    src={`https://www.google.com/maps?q=${property.latitude},${property.longitude}&z=15&output=embed`}
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Around This Home Map"
                  ></iframe>
                </div>

                {/* Tabs Navigation */}
                <Nav variant="tabs" className="around-tabs">
                  {["School", "Place", "Transit"].map((type) => (
                    <Nav.Item key={type}>
                      <Nav.Link
                        active={activeTab.toLowerCase() === type.toLowerCase()}
                        onClick={() => setActiveTab(type.toLowerCase())}
                        className="d-flex align-items-center"
                      >
                        {/* TODO: Replace with SVG icons per type */}
                        {type}
                      </Nav.Link>
                    </Nav.Item>
                  ))}
                </Nav>

                {/* Tab Content */}
                <div className="tab-content-wrap">
                  {Object.keys(property.nearby_locations).map((type) => {
                    if (activeTab.toLowerCase() !== type.toLowerCase())
                      return null;

                    return property.nearby_locations[type].map((loc) => {
                      const isSchool = type.toLowerCase() === "school";
                      const isPlace = type.toLowerCase() === "place";
                      const isTransit = type.toLowerCase() === "transit";

                      return (
                        <Link key={loc.location_id} className="tab-item">
                          <div className="d-flex align-items-center flex-grow-1">
                            <div className="tab-rating">
                              <span className="rating-badge">
                                {loc.rating}/10
                              </span>
                            </div>
                            <div className="tab-info">
                              <h6>
                                {isSchool
                                  ? loc.name
                                  : isPlace
                                    ? loc.name
                                    : loc.name}
                              </h6>
                              <p>
                                {isSchool && "School"}
                                {isPlace && "Place"}
                                {isTransit && loc.type}
                                <span className="dot"></span>
                                {isSchool && `${loc.distance} km`}
                                {isPlace && `${loc.distance} km`}
                                {isTransit && `${loc.distance} m`}
                              </p>
                            </div>
                          </div>
                          <img src={ArrowRight} alt="Arrow" />
                        </Link>
                      );
                    });
                  })}
                </div>
              </div>
              <div className="payment-calculator" id="PaymentCalculator">
                <div className="calculator-header d-flex justify-content-between align-items-center mb-3">
                  <h3 className="mb-0">Payment calculator</h3>
                  <Button
                    variant="link"
                    className="reset-btn text-decoration-none p-0 fw-semibold"
                    onClick={resetCalculator}
                  >
                    Reset
                  </Button>
                </div>

                {/* Monthly Payment Display */}
                <div className="monthly-payment mb-3">
                  <div className="d-flex align-items-center">
                    <h2 className="mb-0 me-2">
                      KES{calculatorResults.totalMonthly} per month
                    </h2>
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="payment-tooltip">
                          This is an estimated monthly payment
                        </Tooltip>
                      }
                    >
                      <img src={TooltipIconOne} alt="info" />
                    </OverlayTrigger>
                  </div>
                </div>

                {/* Progress Bar */}
                <div className="payment-progress mb-4">
                  <div
                    className="progress-multi"
                    style={{
                      height: "8px",
                      borderRadius: "4px",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        width: "68.8%",
                        height: "100%",
                        backgroundColor: "#B3EAE8",
                        float: "left",
                      }}
                    ></div>
                    <div
                      style={{
                        width: "27.7%",
                        height: "100%",
                        backgroundColor: "#8154FF",
                        float: "left",
                      }}
                    ></div>
                    <div
                      style={{
                        width: "0%",
                        height: "100%",
                        backgroundColor: "#F4B7C2",
                        float: "left",
                      }}
                    ></div>
                    <div
                      style={{
                        width: "3.5%",
                        height: "100%",
                        backgroundColor: "#ED8535",
                        float: "left",
                      }}
                    ></div>
                  </div>
                </div>

                {/* Payment Breakdown */}
                <Row className="g-3 mb-4">
                  {paymentBreakdown.map((item, index) => (
                    <Col xs={6} key={index}>
                      <div className="breakdown-item d-flex align-items-center">
                        <div
                          className="color-indicator"
                          style={{
                            backgroundColor: item.color,
                          }}
                        ></div>
                        <div className="breakdown-item-box">
                          <p>{item.label}</p>
                          <h6>KES{item.value}</h6>
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>

                {/* Editable Fields */}
                <div className="calculator-field-wrap mb-4">
                  <div className="calculator-field">
                    <div className="d-flex flex-column justify-content-between align-items-start">
                      <p>Down Payment (%)</p>

                      <h6 className="d-flex align-items-center gap-2">
                        {!isEditingDownPayment ? (
                          <>
                            {downPaymentPercent}% (KES{" "}
                            {calculatorResults.downPayment.toLocaleString()})
                            <img
                              src={EditIcon}
                              alt="Edit"
                              style={{ cursor: "pointer" }}
                              onClick={() => setIsEditingDownPayment(true)}
                            />
                          </>
                        ) : (
                          <Form.Control
                            type="number"
                            value={downPaymentPercent}
                            onChange={(e) =>
                              setDownPaymentPercent(Number(e.target.value))
                            }
                            autoFocus
                            style={{ width: 90 }}
                            onBlur={commitEdit}
                            onKeyDown={(e) => e.key === "Enter" && commitEdit()}
                          />
                        )}
                      </h6>
                    </div>
                  </div>
                  <div className="calculator-border"></div>
                  <div className="calculator-field">
                    <div className="d-flex flex-column justify-content-between align-items-start">
                      <p>Home Price</p>

                      <h6 className="d-flex align-items-center gap-2">
                        {!isEditingPrice ? (
                          <>
                            KES {homePrice.toLocaleString()}
                            <img
                              src={EditIcon}
                              alt="Edit"
                              style={{ cursor: "pointer" }}
                              onClick={() => setIsEditingPrice(true)}
                            />
                          </>
                        ) : (
                          <Form.Control
                            type="number"
                            value={homePrice}
                            onChange={(e) =>
                              setHomePrice(Number(e.target.value))
                            }
                            autoFocus
                            style={{ width: 120 }}
                            onBlur={commitEdit}
                            onKeyDown={(e) => e.key === "Enter" && commitEdit()}
                          />
                        )}
                      </h6>
                    </div>
                  </div>
                  <div className="calculator-border"></div>
                  <div className="calculator-field">
                    <div className="d-flex flex-column justify-content-between align-items-start">
                      <p>Loan Details</p>

                      <h6 className="d-flex align-items-center gap-2">
                        {!isEditingLoan ? (
                          <>
                            {loanYears}-year fixed,{" "}
                            {Number(interestRate).toFixed(2)}%
                            <img
                              src={EditIcon}
                              alt="Edit"
                              style={{ cursor: "pointer" }}
                              onClick={() => setIsEditingLoan(true)}
                            />
                          </>
                        ) : (
                          <div className="d-flex align-items-center gap-2">
                            <Form.Control
                              type="number"
                              min="1"
                              value={loanYears}
                              onChange={(e) =>
                                setLoanYears(Number(e.target.value))
                              }
                              style={{ width: 70 }}
                              autoFocus
                              onKeyDown={(e) =>
                                e.key === "Enter" && commitEdit()
                              }
                            />
                            <span>years</span>

                            <Form.Control
                              type="number"
                              step="0.01"
                              min="0"
                              value={interestRate}
                              onChange={(e) =>
                                setInterestRate(Number(e.target.value))
                              }
                              style={{ width: 80 }}
                              onKeyDown={(e) =>
                                e.key === "Enter" && commitEdit()
                              }
                            />
                            <span>%</span>
                          </div>
                        )}
                      </h6>
                    </div>
                  </div>
                </div>

                {/* Credit Info */}
                <div className="credit-info">
                  <p>
                    Takes about 5 minutes & won't affect your credit
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="credit-tooltip">
                          Soft credit check only
                        </Tooltip>
                      }
                    >
                      <img
                        src={TooltipIconOne}
                        alt="info"
                        width="14"
                        height="14"
                        className="ms-1"
                      />
                    </OverlayTrigger>
                  </p>
                  <Button
                    className="custom-bttn"
                    onClick={() => navigate("/get-pre‑qualified")}
                  >
                    Get Prequalified
                  </Button>
                </div>

                {/* Insurance Details Toggle */}
                <div className="insurance-details">
                  <Button
                    variant="link"
                    className="text-decoration-none d-flex align-items-center"
                    onClick={() =>
                      setShowInsuranceDetails(!showInsuranceDetails)
                    }
                  >
                    Insurance details
                    <img
                      src={DownArrow}
                      alt=""
                      className={`${showInsuranceDetails ? "rotate-180" : ""}`}
                    />
                  </Button>

                  {showInsuranceDetails && (
                    <div className="insurance-details">
                      <p>
                        Great news, homeowners insurance agency, and this
                        estimate is created in partnership with Insurify. Home
                        Insurance of $72/month is extremely healthy when it is
                        licensed in all 50 states and D.C. Estimates are based
                        on the home's purchase price in Burlington County, ID
                        1690 state and zip code.
                      </p>
                    </div>
                  )}
                </div>
              </div>
              <div className="property-details-section" id="PropertyDetails">
                <h3>Property details</h3>
                {/* Parking */}
                <div className="property-section">
                  <h4 className="section-title">Parking</h4>
                  <div className="section-content">
                    <p className="section-label">Parking Spaces</p>
                    <p>
                      {property.parking_spaces ||
                        "No parking information available"}
                    </p>
                  </div>
                </div>
                {Object.keys(property.amenities)
                  .slice(0, showPropertyFullDescription ? undefined : 1)
                  .map((type, index) => (
                    <div className="property-section" key={index}>
                      <h4 className="section-title">{type}</h4>

                      <div className="section-content">
                        <Row>
                          {property.amenities[type].map((item, i) => (
                            <Col md={6} key={i}>
                              <ul>
                                <li>{item.name}</li>
                              </ul>
                            </Col>
                          ))}
                        </Row>
                      </div>
                    </div>
                  ))}

                <Button
                  variant="link"
                  className="p-0 text-decoration-none show-more-btn"
                  onClick={() =>
                    setShowPropertyFullDescription(!showPropertyFullDescription)
                  }
                >
                  {showPropertyFullDescription
                    ? "Show less property details"
                    : "Show more property details"}
                  <img
                    src={DownArrow}
                    alt=""
                    className={showPropertyFullDescription ? "rotate-180" : ""}
                  />
                </Button>
              </div>
            </Col>
            <Col md={12} lg={4} xl={3}>
              <div className="product-sidebar">
                <Button
                  className="custom-bttn w-100 mb-3"
                  onClick={handleShowRequestTour}
                >
                  Request a Tour
                </Button>
                <p className="border-bottom">
                  Tour for free, no strings attached.
                </p>
                <Button
                  className="custom-bttn w-100 style-3  mb-3"
                  onClick={handleShowContactModal}
                >
                  Contact an Agent
                </Button>
                <p>Make a winning offer with the help of a local agent.</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <ContactAgentModal
        property_id={property.id}
        show={showContactModal}
        handleClose={handleCloseContactModal}
        listing_type={property.listing_type}
      />
      <RequestTourModal
        main_image={property.main_image}
        property_id={property.id}
        slots={property.slots}
        street_address={property.street_address}
        beds={property.details.bedrooms}
        baths={property.details.bathrooms}
        size={property.size_sqft}
        show={showRequestTourModal}
        handleClose={handleCloseRequestTour}
        onNext={handleNextFromRequestTour}
      />

      <ConfirmTourModal
        show={showConfirmTourModal}
        handleClose={handleCloseConfirmTour}
        tourData={tourData} listing_type={property.listing_type}
      />
    </>
  );
}
export default ProductDetails;
